module.exports = __webpack_public_path__ + "img/swift.a0967ca8.png";